import React from 'react';
import Checkbox from '@mui/material/Checkbox';

const CheckedIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        {/* Blue Box */}
        <rect x="2" y="2" width="16" height="16" rx="4" fill="#006CDD" />

        {/* White Tick */}
        <path d="M6.4 10.1L8.8 12.5L13.8 7.5" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// Same tick shape as CheckedIcon, but with the disabled fill/stroke colors
// from the reference image (grey box, white tick) instead of the active blue.
const DisabledCheckedIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        {/* Grey Box */}
        <rect x="2" y="2" width="16" height="16" rx="4" fill="#9E9E9E" />

        {/* White Tick */}
        <path d="M6.4 10.1L8.8 12.5L13.8 7.5" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const UncheckedIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="16" height="16" rx="4" fill="#FFFFFF" stroke="#C9CED6" strokeWidth="1.5" />
    </svg>
);

export default function CheckBoxV4(props) {
    // MUI's `checkedIcon` prop has no separate disabled variant of its own —
    // it renders the same checkedIcon regardless of `disabled`, which is why
    // a disabled+checked box was still showing the active blue tick before.
    // Swapping the icon element itself based on `props.disabled` is the fix,
    // and it only affects the checked+disabled combination — unchecked
    // (enabled or disabled) still uses UncheckedIcon exactly as before.
    return (
        <Checkbox
            disableRipple
            icon={<UncheckedIcon />}
            checkedIcon={props.disabled ? <DisabledCheckedIcon /> : <CheckedIcon />}
            {...props}
            sx={{
                p: 0,
                width: 20,
                height: 20,
                minWidth: 20,
                minHeight: 20,

                '&:hover': {
                    backgroundColor: 'transparent',
                },

                '& .MuiTouchRipple-root': {
                    display: 'none',
                },

                ...props.sx,
            }}
        />
    );
}
